import { useQuery } from '@tanstack/react-query';
import {
  getDashboardMetrics,
  getDeviceActivity,
  getErrorsByType,
  getRecentDevices,
} from '@/api/endpoints/dashboard';

export const useDashboardMetrics = () => {
  return useQuery({
    queryKey: ['dashboard', 'metrics'],
    queryFn: getDashboardMetrics,
    staleTime: 1000 * 60,
    retry: 1,
    refetchInterval: 1000 * 60 * 2,
  });
};

export const useDeviceActivity = (period: '24h' | 'yesterday' | '7d' | '30d' | '3m' = '7d') => {
  return useQuery({
    queryKey: ['dashboard', 'device-activity', period],
    queryFn: () => getDeviceActivity(period),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};

export const useErrorsByType = () => {
  return useQuery({
    queryKey: ['dashboard', 'errors-by-type'],
    queryFn: getErrorsByType,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};

export const useRecentDevices = (limit = 10) => {
  return useQuery({
    queryKey: ['dashboard', 'recent-devices', limit],
    queryFn: () => getRecentDevices(limit),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};
